import React from 'react';

export function Spinner() {
  return (
    <svg
      className='animate-spin -ml-1 mr-3 h-5 w-5 text-white bg-blue-900'
      viewBox='0 0 24 24'
    />
  );
}
